<!-- This component is used to display the payment step of the OAP Enrollment Flow -->
<template>
	<SepioOapStep v-if="oapProvider === OapProvider.SEPIO_GUARD" />
	<InmanOapStep v-else />
</template>

<script setup lang="ts">
import InmanOapStep from '@/components/documents/OapStep/InmanOapStep.vue'
import SepioOapStep from '@/components/documents/OapStep/SepioOapStep.vue'
import { OapProvider } from '@/data/oapProviders'
import { useSessionStore } from '@/stores/session'
import { computed } from 'vue'

const sessionStore = useSessionStore()

const oapProvider = computed<OapProvider | undefined>(() => {
	return sessionStore.activeFh?.oap?.data.carrier
})
</script>
